import { useParams } from 'react-router-dom'

import { can } from '@/features/auth/permissions'
import { useSession } from '@/features/auth/use-session'

import { AccessVault } from './AccessVault'

/** Tab "Accesos" de `/companies/:id`. Conecta la sesión con el vault. */
export function CompanyAccessesTab() {
  const { companyId = '' } = useParams()
  const { me } = useSession()

  return (
    <AccessVault
      companyId={companyId}
      canReveal={can(me, 'access:reveal', { companyId })}
      canWrite={can(me, 'access:write', { companyId })}
    />
  )
}
